/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { bulkCandidateWhatsAppStore } from '../../axios/bulkCandidateWhatsAppStore'
import type {
	BulkCandidateWhatsAppStoreError,
	BulkCandidateWhatsAppStoreRequest,
	BulkCandidateWhatsAppStoreResponse,
} from '../../types/BulkCandidateWhatsAppStore'

export const bulkCandidateWhatsAppStoreMutationKey = () => [{ url: '/candidates/bulk-whatsapp' }] as const

export type BulkCandidateWhatsAppStoreMutationKey = ReturnType<typeof bulkCandidateWhatsAppStoreMutationKey>

export type BulkCandidateWhatsAppStoreVariables = {
	data: BulkCandidateWhatsAppStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/BulkCandidateWhatsAppController.php BulkCandidateWhatsAppController::store */
export function useBulkCandidateWhatsAppStore<TContext = unknown>(
	options?: UseMutationOptions<
		BulkCandidateWhatsAppStoreResponse,
		AxiosError<BulkCandidateWhatsAppStoreError>,
		BulkCandidateWhatsAppStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: bulkCandidateWhatsAppStoreMutationKey(),
		mutationFn: ({ data }: BulkCandidateWhatsAppStoreVariables) =>
			bulkCandidateWhatsAppStore(data, config).then(res => res.data),
		...options,
	})
}
